import { render, staticRenderFns } from "./PdfPageContainer.vue?vue&type=template&id=6db56ce8&"
import script from "./PdfPageContainer.vue?vue&type=script&lang=js&"
export * from "./PdfPageContainer.vue?vue&type=script&lang=js&"
import style0 from "./PdfPageContainer.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports